import React, { useState } from "react";
import { Container, Box } from "@mui/material";
import { ChevronDown, ChevronUp } from "react-feather";

const Most = ({ location = [] }) => {
  const [visibleSections, setVisibleSections] = useState({});

  const toggleSectionVisibility = (index) => {
    setVisibleSections((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <Container maxWidth="lg" className="mt-12">
      <Box className="text-2xl text-gray-700 uppercase mb-4">
        Түгээмэл асуулт хариулт
      </Box>

      <Box className="w-full pb-2">
        {location.map((item, index) => (
          <Box
            key={index}
            className="rounded-lg mb-2 text-gray-700 bg-white shadow-md cursor-pointer"
          >
            {/* Toggle Header */}
            <Box
              className="flex justify-between items-center p-3"
              onClick={() => toggleSectionVisibility(index)}
            >
              <Box className="text-sm font-bold">
                {index + 1}. {item.name}
              </Box>
              {visibleSections[index] ? (
                <ChevronUp size={24} className="text-gray-600" />
              ) : (
                <ChevronDown size={24} className="text-gray-600" />
              )}
            </Box>

            {/* Toggle Content */}
            {visibleSections[index] && (
              <Box className="px-4 pb-8 text-sm leading-6">
                <Box className="mt-6 pb-4">
                  <Box className="flex items-center mb-4">
                    <span className="text-gray-600">{item.description}</span>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default Most;
